import React, { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode';
import DashboardNav from '../../components/Nav/DashboardNav'
import CountrySelector from '../Home/CountrySelector'
import CategorySelector from '../Home/CategorySelector'
import VendorSelector from '../Home/VendorSelector'
import search_icon from '../assets/search.svg'
import Footer from '../../components/Footer/Footer'
import Review from '../../components/Review/Review'
import { useNavigate } from 'react-router-dom';
import errorIcon from '../../components/assets/error.svg';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import smallRatedPeople from '../assets/herosectionimage.png'
import ratedPeople from '../assets/herosectionimage.png'
import { ChevronLeft } from "lucide-react";
import { ChevronRight } from "lucide-react";
import VendorDashboard from './Vendordashboard';
import VendorCTA from '../../components/VendorCTA';
import SavedVendors from '../../components/SavedVendors';


const Dashboard = ({ reviewData, vendorCountryData, categoryData, vendorData,savedVendorData, setSavedVendorData, toggleSaveVendor }) => {
  const [country, setCountry] = useState('')
  const [category, setCategory] = useState('')
  const [vendor, setVendor] = useState('')
  const [createAccount, setCreateAccount] = useState(null)
  const [user, setUser] = useState(null)
  const vendorOwner =
    user?.user_type === 'vendor' &&
    vendorData?.some(v => v.user_id === user?.user_id);
  const vendorOwnerData = vendorData?.find(v => v.user_id === user?.user_id);
  const [accessToken, setAccessToken] = useState()
  const navigate = useNavigate();
  const [searchError, setSearchError] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // To keep track of filtered options
  const [filteredVendors, setFilteredVendors] = useState(vendorData);
  const [filteredCountries, setFilteredCountries] = useState(vendorCountryData);
  const [filteredCategories, setFilteredCategories] = useState(categoryData);
  const [activeTab, setActiveTab] = useState("reviews");

  // Function that returns how many reviews to show per page based on screen size 
  const getPerPage = () => {
    const w = window.innerWidth;
    if (w < 744) return 3;       // mobile
    if (w < 1024) return 4;      // tablet
    return 6;                     // desktop
  };

  const [perPage, setPerPage] = useState(getPerPage()); // how many items to show per page based on screen width
  const [currentPage, setCurrentPage] = useState(1); //  controls which page is currently selected
  const [showPagination, setShowPagination] = useState(false); // determines if pagination UI should be visible

  const [hasShownMore, setHasShownMore] = useState(false); // State: tracks if the "show more" button has already been clicked


  // Function to handle vendor selection and automatically filter categories and countries
  const handleVendorSelect = (selectedVendor) => {
    setVendor(selectedVendor);

    // Filter categories and countries based on selected vendor
    const vendorCategories = vendorData.filter(v => v.vendor_name === selectedVendor)
      .map(v => v.category.category_name);
    const vendorCountries = vendorData.filter(v => v.vendor_name === selectedVendor)
      .map(v => v.vendor_country.vendor_country_name);

    //setFilteredCategories(categoryData.filter(c => vendorCategories.includes(c.category_name)));
    // setFilteredCountries(vendorCountryData.filter(c => vendorCountries.includes(c.vendor_country_name)));
  };

  // Function to handle category selection and automatically filter vendors and countries
  const handleCategorySelect = (selectedCategory) => {
    setSelectedCategory(selectedCategory); // Store selected category in state
    setCategory(selectedCategory);

    // Start filtering vendors by category
    let categoryVendors = vendorData.filter(v => v.category.category_name === selectedCategory);

    // If a country is selected, filter vendors by both country and category
    if (selectedCountry) {
      categoryVendors = categoryVendors.filter(v => v.vendor_country.vendor_country_name === selectedCountry);
    }

    // Get unique country names for filtered vendors
    const categoryCountryNames = [...new Set(categoryVendors.map(v => v.vendor_country.vendor_country_name))];
    const categoryCountries = vendorCountryData.filter(v => categoryCountryNames.includes(v.vendor_country_name));

    setFilteredVendors(categoryVendors);
    //setFilteredCountries(categoryCountries);
  };


  // Function to handle country selection and automatically filter vendors and categories
  const handleCountrySelect = (selectedCountry) => {
    setSelectedCountry(selectedCountry); // Store selected country in state
    setCountry(selectedCountry);

    // Filter vendors based on the selected country
    const countryVendors = vendorData.filter(v => v.vendor_country.vendor_country_name === selectedCountry);

    // Get unique category names for vendors in the selected country
    const countryCategoryNames = [...new Set(countryVendors.map(v => v.category.category_name))];

    // Filter categories based on selected country
    const countryCategories = categoryData.filter(c => countryCategoryNames.includes(c.category_name));

    setFilteredVendors(countryVendors);
    // setFilteredCategories(countryCategories);
  };


  // Handle Search functionality
  const handleSearch = () => {
    if (vendor?.length < 1 && category?.length < 1 && country?.length < 1) {
      setSearchError('Invalid Search');
      return;
    } else if (vendor?.length < 1) {
      setSearchError('Vendor is Required');
      return;
    } else if (category?.length < 1 && country?.length < 1) {
      setSearchError('Category or Country is Required');
      return;
    }

    else {

      let filterSearchedVendor = vendorData;
      if (vendor?.length > 0) {
        filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
          vendorItem?.vendor_name?.toLowerCase()?.includes(vendor?.toLowerCase())
        );
      }

      if (category?.length > 0) {
        filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
          vendorItem?.category?.category_name?.toLowerCase()?.includes(category?.toLowerCase())
        );
      }

      if (country?.length > 0) {
        filterSearchedVendor = filterSearchedVendor?.filter(vendorItem =>
          vendorItem?.vendor_country?.vendor_country_name?.toLowerCase()?.includes(country?.toLowerCase())
        );
      }

      if (filterSearchedVendor.length === 0) {
        setSearchError('No vendors found for the given search criteria.');
      } else {
        setSearchError('');
        // Assuming filterSearchedVendor contains only one vendor data point
        const vendorId = filterSearchedVendor[0]?.vendor_id; // Extract vendor_id from filterSearchedVendor

        // Filter reviewData based on the vendor_id
        const filteredVendorData = reviewData.filter(review => review.vendor.vendor_id === vendorId);
        navigate('/vendor', { state: { user: user, vendor: filterSearchedVendor[0], filteredVendorData: filteredVendorData } });
      }
    }
  };

  // Decode the data 
  function decodeData(data) {
    return atob(data); // Base64 encoding
  }

  useEffect(() => {
    const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);

    // Decode the JWT token
    const decodedToken = storeToken ? decodeData(storeToken) : null;
    const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
    if (userInfo) {
      setAccessToken(decodedToken)
      setUser(userInfo?.user)
    }
    else {
      navigate('/');
    }
  }, [navigate])

  useEffect(() => {
    setFilteredCountries(vendorCountryData)
    setFilteredCategories(categoryData)
    setFilteredVendors(vendorData)
  }, [vendorCountryData, categoryData, vendorData])

  // Function to update the perPage value whenever the screen resizes
  useEffect(() => {
    const handleResize = () => {
      setPerPage(getPerPage());
    };

    window.addEventListener("resize", handleResize); // Add resize event listener
    return () => window.removeEventListener("resize", handleResize);  // remove event listener when component unmounts
  }, []);

  const sortedReviews = [...reviewData].sort((a, b) => b.feedback_id - a.feedback_id);
  const displayedReviews = sortedReviews.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );


  // Only reviews for the logged-in vendor
  const vendorReviews = reviewData?.filter(
    (review) => review?.vendor?.vendor_id === vendorOwnerData?.vendor_id
  );


  


  return (
    <div className='overflow-x-hidden '>
      {!vendorOwner ? (
        <>
          <DashboardNav />
          <div className=' pt-[340px] pb-[110px] md:pt-[150px] lg:pt-[165px] md:pb-[110px] lg:pb-[183px] xl:pb-[245px] w-full flex flex-col  mg:pl-[64px] gap-[30px] bg-custom-gradient h-[737px] md:h-[469px] lg:h-[524px] xl:h-[560px] overflow-x-hidden'>

            <div className='md:pl-[32px] mg:pl-0'>
              <div className='  flex flex-col items-center md:items-start text-center xl:justify-end md:flex-row gap-[30px]'>
                <img src={ratedPeople} alt="ratedpeople" className='absolute md:-top-[260px] md:block lg:-top-[277px] xl:-top-[330px] md:right-[32.41px]  lg:right-[47.85px] xl:right-[73px] hidden md:w-[380px] md:h-auto lg:w-[420px] xl:w-[470px] ' />
                <img src={smallRatedPeople} alt="smallRatedPeople" className='absolute top-[124px] max-w-[300px] h-auto flex md:hidden' />
              </div>


              {/* Large Screen Search */}
              <div className=' absolute z-[80] w-full hidden flex-grow  md:flex flex-col items-start  xl:justify-center gap-[19px] lg:gap-[23px]  xl:gap-[29px]  md:max-w-[480px] xl:max-w-[729px]'>
                <div className="hidden md:top-[164px] md:left-[34px] lg:top-[199px] lg:left-[32px] mg:left-[64px] md:flex flex-col text-white text-center md:w-[314px] md:h-[96px] lg:w-[545px] lg:h-[90px] xl:w-[640px] xl:h-[117px] md:text-start md:gap-[14px]">
                  <h1 className="font-black text-[28px] lg:text-[40px] xl:[60px] leading-[47.25px] lg:leading-[54px]">
                    Hi {user?.first_name},
                  </h1>

                  <h2 className="font-normal text-[16px] leading-[24px]">
                    Your voice matters. Review vendors or become one
                  </h2>
                </div>

                <div className='w-full flex justify-between z-[40]'>
                  <div className={`w-full flex items-center rounded-l-[80px] border-solid border-[1px] ${searchError === 'Invalid Search' ? 'border-2  bg-white border-[#EB0728] text-[#EB0728]' : 'border-[#C1C1C180] bg-white'} transform transition-all ease-in-out duration-300`}>
                    <CountrySelector page='dashboard' searchError={searchError} setSearchError={setSearchError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="large" />
                    <div className='border border-[1.5px] h-[25px] bg-[#C1C1C1]' />
                    <CategorySelector page='dashboard' searchError={searchError} setSearchError={setSearchError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="large" />
                    <div className='border border-[1.5px] h-[25px] bg-[#C1C1C1]' />
                    <VendorSelector page='dashboard' searchError={searchError} setSearchError={setSearchError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="large" />
                  </div>
                  <button onClick={() => handleSearch()} className='w-full max-w-[52px] h-[47px] xl:h-[52px] rounded-r-[80px] flex items-center justify-center bg-[#0079FF] hover:opacity-70 transform transition-all ease-in-out duration-300'>
                    <img src={search_icon} alt="search_icon" className='w-[18.75px] h-[18.75px]' />
                  </button>
                </div>
              </div>

            </div>

            <div className="absolute top-[131px] left-6 md:hidden flex flex-col w-[291px] h-[98px] items-start text-white text-start gap-[2px] space-y-1">
              <h1 className="font-black text-[25px] leading-[33.75px]">
                Hi {user?.first_name},
              </h1>

              <h2 className="font-normal text-[16px] leading-[24px]">
                Your voice matters. Review vendors or become one
              </h2>
            </div>


            {/**Error Display */}
            {searchError !== "" ? (
              <div className='relative -top-[20px] md:top-[1px] md:right-[15%] lg:top-[5px] lg:right-[25%] xl:top-[px] xl:right-[25%] w-full flex items-center justify-center mb-[-40px] transform transition-all ease-in-out duration-300'>
                <div className="w-fit flex gap-[8px] items-center bg-[#FFDFE4] rounded-[30px]  px-[12px] h-[30px]">
                  <img src={errorIcon} alt="" className="size-[14px]" />
                  <p className="font-normal text-[#EB0728] text-[10px] leading-[12.13px]">
                    {searchError}
                  </p>
                </div>
              </div>
            ) : null}



            {/**Small Screen Search */}
            <div className='absolute top-[276px] w-full flex md:hidden flex-col gap-3 px-[24px]  z-[80]'>
              <CountrySelector page='dashboard' searchError={searchError} setSearchError={setSearchError} vendorCountryData={filteredCountries} handleCountrySelect={handleCountrySelect} device="small" />
              <CategorySelector page='dashboard' searchError={searchError} setSearchError={setSearchError} categoryData={filteredCategories} handleCategorySelect={handleCategorySelect} device="small" />
              <div className='w-full flex'>
                <VendorSelector page='dashboard' searchError={searchError} setSearchError={setSearchError} vendorData={filteredVendors} handleVendorSelect={handleVendorSelect} device="small" />
                <button onClick={() => handleSearch()} className=' z-20 relative w-full max-w-[52px] h-[47px] xl:h-[52px] rounded-r-[80px] flex items-center justify-center bg-[#0079FF] hover:opacity-70 transform transition-all ease-in-out duration-300'><img src={search_icon} alt="search_icon" className=' w-[18.75px] h-[18.75px]' /></button>
              </div>
            </div>

          </div>
          {/**Recent reviews */}

          {/**Recent reviews */}
          <div className='relative  w-full -mt-[85px] md:-mt-[55px]  rounded-t-[50px] md:rounded-t-[40px] lg:rounded-t-[50px] pt-[37px] md:pt-[32px] px-[24px] md:px-[32px] xl:px-[64px] bg-white z-[10]'>
            <div className="w-full flex justify-center mb-6">

              <div className="flex bg-white border-[1.5px] border-[#c1c1c1]/50  rounded-full p-[5px]">

                {/* Recent Reviews */}
                <button
                  onClick={() => setActiveTab("reviews")}
                  className={`px-4  py-2.5 rounded-full text-[18px] text-nowrap font-bold transition-all
                     ${activeTab === "reviews"
                      ? "bg-[#0079FF] text-white shadow"
                      : "text-black hover:bg-gray-100"
                    }`}
                >
                  Recent Reviews
                </button>

                {/* Saved Vendors */}
                <button
                  onClick={() => setActiveTab("saved")}
                  className={`px-4  py-2.5 rounded-full text-nowrap text-[18px] text-nowrap font-bold transition-all
                   ${activeTab === "saved"
                      ? "bg-[#0079FF] text-white shadow"
                      : "text-black hover:bg-gray-100"
                    }`}
                >
                  Saved Vendors
                </button>

              </div>

            </div>
            <VendorCTA  user={user}/>

            {activeTab === "reviews" && ( <>
              <div className='grid grid-cols-[repeat(auto-fill,_minmax(327px,_1fr))] lg:grid-cols-[repeat(auto-fill,_minmax(310px,_1fr))] xl:grid-cols-[repeat(auto-fill,_minmax(426px,_1fr))] mt-[33px] md:mt-[27px] w-full flex flex-wrap gap-[30px] md:gap-[24px] lg:gap-x-[15px] xl:gap-x-[16px] gap-y-[30px] md:gap-y-[40px] lg:gap-y-[36px] xl:gap-y-[60px]'>
                {displayedReviews && displayedReviews.length > 0 ? (
                  displayedReviews
                    .sort((a, b) => b.feedback_id - a.feedback_id) // keep sorting
                    .map((item, index) => (
                      <Review key={index} item={item} user={user} accessToken={accessToken} setCreateAccount={setCreateAccount} />

                    ))
                ) : null}
              </div>

            {!hasShownMore && reviewData.length > perPage && (
              <div className="flex justify-center mt-8">
                <button
                  onClick={() => { setHasShownMore(true); setShowPagination(true); setCurrentPage(2); }}
                  className="px-6 h-[44px] bg-white border-ravblue border text-ravblue rounded-[80px] font-bold hover:opacity-70 transition"> Show More </button>
              </div>
            )}

            {showPagination && reviewData.length > perPage && (
              <div className=" flex items-center justify-center gap-0 mt-12 bg-[#E5E5E5]/50 rounded-[80px] h-[45px] w-fit px-1 mx-auto">
                {/* Prev button */}
                <button
                  disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)} className={`flex items-center gap-[3px] pl-4 pr-[19px] py-2 text-nowrap font-medium text-[14px] text-black  ${currentPage === 1 ? 'cursor-not-allowed' : ""} transition`}> <ChevronLeft size={20} /> <span>Prev</span></button>
                {/* Page numbers */}
                <div className="bg-white rounded-[10px] w-fit px-2 border flex items-center h-[35px]">
                  {(() => {
                    const totalPages = Math.ceil(reviewData.length / perPage);
                    const windowSize = 5;
                    const windowStart = Math.floor((currentPage - 1) / windowSize) * windowSize;
                    return Array.from(
                      { length: Math.min(windowSize, totalPages - windowStart) },
                      (_, i) => {
                        const page = windowStart + i + 1;
                        return (
                          <button key={page} onClick={() => setCurrentPage(page)} className={`gap-0 mx-auto py-[5px] items-center justify-center w-[27px] flex h-[24px] rounded-[6px] font-medium text-[14px] transition ${currentPage === page ? "bg-ravblue text-white" : "text-black hover:bg-gray-100"}`}
                          >
                            {page}
                          </button>
                        );
                      }
                    );
                  })()}
                </div>
                {/* Next button */}
                <button disabled={currentPage === Math.ceil(reviewData.length / perPage)} onClick={() => setCurrentPage(prev => prev + 1)} className={`flex px-4 font-medium text-black text-[14px] py-2 ${currentPage === Math.ceil(reviewData.length / perPage) ? ' cursor-not-allowed' : ""} transition`}> <span>Next</span> <ChevronRight size={20} /></button>
              </div>
            )}</>)}
            {activeTab === "saved" && (
  <>
    {savedVendorData && savedVendorData.length > 0 ? (
      <div className='mb-[304px] md:mb-[348px] lg:mb-[439px] xl:mb-[578px]'>
      <SavedVendors savedVendorData={savedVendorData} toggleSaveVendor={toggleSaveVendor} user={user} reviewData={reviewData}/>
      </div>
    ) : (
      <div className="w-full flex flex-col items-center justify-center py-20">
        <h2 className="font-bold text-[20px] leading-[30px] text-center">
          You have no saved vendors yet.
        </h2>
        <p className="font-normal text-[16px] leading-[24px] text-center mt-2">
          Browse vendors and save your favorites to see them here.
        </p>
      </div>
    )}
  </>
)}


          </div>


        </>)
        :
        <><VendorDashboard user={user} vendorOwnerData={vendorOwnerData} reviewData={reviewData} />
          {/**Recent vendor owner reviews */}
          <div className='relative  w-full -mt-[85px] md:-mt-[55px]  rounded-t-[50px] md:rounded-t-[40px] lg:rounded-t-[50px] pt-[37px] md:pt-[32px] px-[24px] md:px-[32px] xl:px-64px] bg-white z-[10]'>
            <h1 className=' font-bold text-[18px] md:text-[25px]'>Recent reviews</h1>
            <div className='grid grid-cols-[repeat(auto-fill,_minmax(327px,_auto))] lg:grid-cols-[repeat(auto-fill,_minmax(380px,_auto))] mt-[33px] md:mt-[27px] w-full gap-[30px] md:gap-[26px] xl:gap-x-[40px] gap-y-[30px]'>
              {vendorReviews && vendorReviews.length >0 ? (
                vendorReviews
                  .sort((a, b) => b.feedback_id - a.feedback_id) // Sort by latest
                  .slice(0, 150) // Limit number of reviews if needed
                  .map((item, index) => (
                    <Review
                      key={index}
                      item={item}
                      user={user}
                      accessToken={accessToken}
                      setCreateAccount={setCreateAccount}
                    />
                  ))
              ) : (
<div className="col-span-full w-full flex justify-center mt-[10px]">
  <p className="text-center font-medium text-ravash text-sm">
    Sorry, you do not have any reviews yet.
    <span> Encourage your clients to leave reviews.</span>
  </p>
</div>
              )}
            </div>



          </div></>}
      <Footer />
    </div>
  )
}

export default Dashboard
